import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Category = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.categoryList,
		[allFilterPages.SAMPLE_DETAILS]: dependentFilterList?.categoryList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.categoryList,
		[allFilterPages.COSTING_DETAILS]: dependentFilterList?.categoryList,
		[allFilterPages.POM_LIST]: dependentFilterList?.subCategoryList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.subCategoryList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.id, name: item.name, count: item?.count || null };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="CATEGORY" />
			<Checkbox data={data} type="CATEGORY" handleSearch={handleSearch} />
		</>
	);
};

export default Category;
